import { Injectable, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import {Product} from "../../models/product";

@Injectable({
    providedIn: 'root'
})
export class AddProductEmitterService {

    invokeAddProduct = new EventEmitter<Product>();
    subsAddProduct: Subscription;

    constructor() { }

    onAddProduct(product: Product) {
        this.invokeAddProduct.emit(product);
    }
}
